// Patent office codes
export const patentOffices = [
  "WO",
  "US",
  "EP",
  "JP",
  "KR",
  "CN",
  "AE",
  "AG",
  "AL",
  "AM",
  "AO",
  "AP",
  "AR",
  "AT",
  "AU",
  "AW",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BJ",
  "BN",
  "BO",
  "BR",
  "BW",
  "BX",
  "BY",
  "BZ",
  "CA",
  "CF",
  "CG",
  "CH",
  "CI",
  "CL",
  "CM",
  "CO",
  "CR",
  "CS",
  "CU",
  "CY",
  "CZ",
  "DD",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EA",
  "EC",
  "EE",
  "EG",
  "EM",
  "ES",
  "FI",
  "FR",
  "GA",
  "GB",
  "GC",
  "GD",
  "GE",
  "GH",
  "GM",
  "GN",
  "GQ",
  "GR",
  "GT",
  "GW",
  "HK",
  "HN",
  "HR",
  "HU",
  "IB",
  "ID",
  "IE",
  "IL",
  "IN",
  "IR",
  "IS",
  "IT",
  "JO",
  "KE",
  "KG",
  "KH",
  "KM",
  "KN",
  "KP",
  "KW",
  "KZ",
  "LA",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MG",
  "MK",
  "ML",
  "MN",
  "MO",
  "MR",
  "MT",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NE",
  "NG",
  "NI",
  "NL",
  "NO",
  "NZ",
  "OA",
  "OM",
  "PA",
  "PE",
  "PG",
  "PH",
  "PL",
  "PT",
  "PY",
  "QA",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SC",
  "SD",
  "SE",
  "SG",
  "SI",
  "SK",
  "SL",
  "SM",
  "SN",
  "ST",
  "SU",
  "SV",
  "SY",
  "SZ",
  "TD",
  "TG",
  "TH",
  "TJ",
  "TM",
  "TN",
  "TR",
  "TT",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UY",
  "UZ",
  "VC",
  "VE",
  "VN",
  "YU",
  "ZA",
  "ZM",
  "ZW",
];
